
import React from 'react';
import { ResourceFile } from "../../types";
import { TrainingInteractiveContentViewer } from "../TrainingInteractiveContentViewer";

interface InteractiveContentTypeHandlerProps {
  currentFile: ResourceFile;
  resourceId: string;
  isFreeResponseView: boolean;
  isDragDropView: boolean;
  isLinkingView: boolean;
  handleContentComplete: () => void;
  handleDragDropComplete: (fileId: string, attempt: any) => Promise<void>;
}

export function InteractiveContentTypeHandler({
  currentFile,
  resourceId,
  isFreeResponseView,
  isDragDropView,
  isLinkingView,
  handleContentComplete,
  handleDragDropComplete
}: InteractiveContentTypeHandlerProps) {
  let contentType: 'free_response' | 'drag_drop' | 'linking' = 'free_response';
  
  if (isDragDropView) contentType = 'drag_drop';
  if (isLinkingView) contentType = 'linking';
  
  return (
    <TrainingInteractiveContentViewer
      type={contentType}
      fileId={currentFile.file_id || currentFile.id}
      resourceId={resourceId}
      onComplete={handleContentComplete}
      onGameUpdate={handleDragDropComplete}
    />
  );
}
